/* Repairs and behaviour layered on top of thankful-pbc.js.

   1. Header cart badge only read the cart once on load.
   2. Stat counters could freeze mid-animation on a hidden tab and
      show "5g PROTEIN" instead of "12g".
   3. Breadcrumbs are plain text; the store root is the Thankful page.
   4. Quantity applies to both purchase options.
   5. THE IMPORTANT ONE. The base script only records the chosen
      selling plan when the frequency dropdown fires a change event,
      and never clears it when someone switches to One-time. Left
      alone that means Subscribe & Save adds a plain item at full
      price, and a later one-time order can silently carry a
      subscription. The plan is now recomputed from the live state
      immediately before every add to cart.

      Note on the listener below: it sits on `document`, not on the
      button. A capture listener added to the button itself would
      still run after the base script's handler, because listeners on
      the target element fire in the order they were registered
      regardless of the capture flag. On an ancestor it genuinely
      runs first. */
(function () {
  'use strict';

  var CFG = window.TKF_CONFIG || {};
  var mode = 'bundle';
  var money = function (c) { return '$' + (c / 100).toFixed(2); };

  function deadenCrumbs() {
    document.querySelectorAll('.tkf .crumbs a').forEach(function (a) {
      var s = document.createElement('span');
      s.className = a.className;
      s.textContent = a.textContent;
      a.parentNode.replaceChild(s, a);
    });
  }

  function syncBadge() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.tkf-count').forEach(function (n) {
          n.textContent = cart.item_count;
          n.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    url = (url && url.url) ? url.url : String(url);
    var call = nativeFetch.apply(this, arguments);
    if (url.indexOf('/cart/') !== -1) {
      call.then(function () { setTimeout(syncBadge, 60); }).catch(function () {});
    }
    return call;
  };

  function settleCounts() {
    document.querySelectorAll('.tkf [data-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) return;
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      var want = target.toFixed(dec) + (el.getAttribute('data-suffix') || '');
      if (el.textContent !== want) el.textContent = want;
    });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) settleCounts();
  });
  window.addEventListener('pagehide', settleCounts);
  setInterval(function () { if (document.hidden) settleCounts(); }, 2000);

  function activeTier() {
    return document.querySelector('.tkf .tier.is-active') ||
           document.querySelector('.tkf .tier');
  }

  function currentMode() {
    var once = document.querySelector('.tkf .plan--once');
    return (once && once.classList.contains('is-selected')) ? 'once' : 'bundle';
  }

  function syncPrices() {
    var t = activeTier();
    if (!t) return;
    var cents = parseInt(t.getAttribute('data-price'), 10);
    if (isNaN(cents)) return;

    var once = document.getElementById('tkfOncePrice');
    if (once) once.textContent = money(cents);

    var sub = document.getElementById('tkfBundlePrice');
    if (!sub) return;
    var vid = t.getAttribute('data-vid');
    var freq = document.getElementById('tkfFreq');
    var table = window.TKF_SUB_PRICES || {};
    var forVariant = table[vid];
    var planPrice = null;
    if (forVariant) {
      if (freq && forVariant[freq.value] != null) planPrice = forVariant[freq.value];
      else { for (var k in forVariant) { planPrice = forVariant[k]; break; } }
    }
    sub.textContent = money(planPrice != null ? planPrice : cents);
  }

  function pointOnceAtTier() {
    var t = activeTier();
    if (t) CFG.singleVariantId = t.getAttribute('data-vid');
  }

  /* Make the base script's stored selling plan match what is on screen. */
  function applyPlanState() {
    var freq = document.getElementById('tkfFreq');
    if (!freq) return;                        // no plans on the store yet
    mode = currentMode();                     // read the DOM, don't trust a flag
    if (mode === 'once') {
      var chosen = freq.value;
      freq.value = '';                        // matches no option, so value is ''
      freq.dispatchEvent(new Event('change')); // base script stores null
      freq.value = chosen;                    // restore what the customer sees
    } else {
      freq.dispatchEvent(new Event('change')); // base script stores the plan id
    }
  }

  function wireQuantity() {
    document.querySelectorAll('.tkf .plan').forEach(function (p) {
      p.addEventListener('click', function (e) {
        if (e.target.closest('.tier') || e.target.closest('select')) return;
        setTimeout(function () { syncPrices(); applyPlanState(); }, 0);
      });
    });

    document.querySelectorAll('.tkf .tier').forEach(function (t) {
      t.addEventListener('click', function () {
        setTimeout(function () {
          pointOnceAtTier();
          syncPrices();
          if (mode === 'once') {
            var head = document.querySelector('.tkf .plan--once .plan-head');
            if (head) head.click();
          }
          applyPlanState();
        }, 0);
      });
    });

    var freq = document.getElementById('tkfFreq');
    if (freq) freq.addEventListener('change', syncPrices);

    // Runs before anything on the button, because it is on an ancestor.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#tkfAtc')) applyPlanState();
    }, true);

    pointOnceAtTier();
    syncPrices();
    applyPlanState();
  }

  function start() {
    deadenCrumbs();
    syncBadge();
    wireQuantity();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();